import React from 'react'
import {
  useRecoilValue,
  useResetRecoilState,
  useRecoilCallback
} from 'recoil'

import {
  ModalConfirm
} from 'mailup-web-components'

import {
  modalStopSendingState
} from '../recoil/state/modals'

import {
  stopRunningSendingConfirmCallback,
  stopScheduledSendingConfirmCallback
} from '../recoil/callbacks/callbacks'

import { useIntl } from 'react-intl'

import partial from 'Helpers/partial'

const ModalStopRunning = () => {
  const intl = useIntl()
  const { show, idSending, mode } = useRecoilValue(modalStopSendingState)
  const message =
  mode === 'running'
    ? intl.formatMessage({ id: 'Load.Schedulation.StoppingSendingConfirmIntl' }, {
      strong: tokens => (<strong>{tokens}</strong>),
      linebreak: (<br />)
    })
    : intl.formatMessage({ id: 'Load.Schedulation.StoppingSendingReadyConfirmIntl' }, {
      linebreak: (<br />)
    })
  const handleCancel = useResetRecoilState(modalStopSendingState)

  const handleConfirm = partial(
    useRecoilCallback(
      mode === 'running'
        ? stopRunningSendingConfirmCallback
        : stopScheduledSendingConfirmCallback
      , [mode]),
    idSending
  )

  return (
    <ModalConfirm
      show={show}
      title={intl.formatMessage({ id: 'Load.Schedulation.StoppingSendingConfirmTitle' })}
      message={message}
      onClickCancel={handleCancel}
      onClickConfirm={handleConfirm}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.No' })}
      stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Yes' })}
      data-mu-test='modal-stop-sending'
    />

  )
}

export default ModalStopRunning
